/**
 * Activity GraphQL Queries
 */

export const GET_ACTIVITIES_DASHBOARD = `
  query GetActivitiesDashboard($offset: Int!, $limit: Int!) {
    pep_vw_activity_dashboard(offset: $offset, limit: $limit, order_by: {activity_id: desc}) {
      activity_id
      activity_name
      created_by
      created_by_name
      group_name
      is_active
      patient_group_id
      updated_by
      updated_by_name
      user_group_id
      workflow_id
      workflow_name
    }
  }
`;

export const GET_ACTIVITIES_COUNT = `
  query GetActivitiesCount {
    pep_vw_activity_dashboard_aggregate {
      aggregate {
        count
      }
    }
  }
`;

export const SEARCH_ACTIVITIES_DASHBOARD = `
  query SearchActivitiesDashboard($searchValue: String!, $offset: Int!, $limit: Int!) {
    pep_vw_activity_dashboard(
      where: {
        _or: [
          { activity_name: { _ilike: $searchValue } }
          { group_name: { _ilike: $searchValue } }
          { workflow_name: { _ilike: $searchValue } }
        ]
      }
      offset: $offset
      limit: $limit
      order_by: {activity_id: desc}
    ) {
      activity_id
      activity_name
      created_by
      created_by_name
      group_name
      is_active
      patient_group_id
      updated_by
      updated_by_name
      user_group_id
      workflow_id
      workflow_name
    }
  }
`;

export const SEARCH_ACTIVITIES_COUNT = `
  query SearchActivitiesCount($searchValue: String!) {
    pep_vw_activity_dashboard_aggregate(
      where: {
        _or: [
          { activity_name: { _ilike: $searchValue } }
          { group_name: { _ilike: $searchValue } }
          { workflow_name: { _ilike: $searchValue } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_ACTIVITY_AUDIT_LOG = `
  query GetActivityAuditLog($activityId: Int!) {
    pep_activity_audit_log(where: {activity_id: {_eq: $activityId}}, order_by: {action_datetime: desc}) {
      pep_activity_audit_log_id
      activity_id
      action_type
      action_datetime
      action_by
      activity_data
      metadata
    }
    pep_activity_audit_log_aggregate(where: {activity_id: {_eq: $activityId}}) {
      aggregate {
        count
      }
    }
  }
`;
